<template>
    <div class="news-content-container">
      <back-open-chenter />
      <div class="news-content-panel">
        <div class="news-title">PRCV2024大会正式召开，腾讯优图携前沿科技成果亮相现场</div>
        <div class="news-date">2024年10月21日</div>
        <div class="news-content">
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
            </div>
          </div>
          <p>
            10月18日-20日，由中国自动化学会（CAA）、中国图象图形学学会（CSIG）、中国人工智能学会（CAAI）和中国计算机学会（CCF）联合主办，新疆大学承办的第七届中国模式识别与计算机视觉大会（PRCV 2024）在乌鲁木齐举办。 
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/newscenter/news57.png"/>
            </div>
          </div>
          <p>
            作为国内顶级的模式识别和计算机视觉领域学术盛会，本届会议旨在汇聚国际国内模式识别和计算机视觉领域的广大科研工作者及工业界同行，分享最新理论研究进展和技术研发成果。通过此次会议，能加强本领域学术界和企业界进行深入的“产学研”交流与合作，从而进一步促进模式识别与计算机视觉领域的协同创新。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news57/news57_1.png"/>
            </div>
          </div>
          <p>
            今年，腾讯优图实验室再次受邀参加PRCV，来自腾讯优图实验的的算法研究员
            <span class="mark-text highlight">沈云航在现场论坛带来《迈向交互式全模态大模型》</span>
            的主题分享，报告围绕大模型，介绍了包括通用视觉感知基础模型APE、弱监督开放词汇目标检测WSOVOD和全模态大语言模型VITA在内的从多模态视觉模型到多模态大语言模型的工作。
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news57/news57_2.png"/>
            </div>
          </div>
          <p>
            此次，腾讯优图实验室还带来了
            <span class="mark-text highlight">腾讯云大模型知识引擎、腾讯云大模型图像创作引擎、腾讯云大模型视频创作引擎、腾讯云智能数智人、AI+新天体搜索</span>
            和
            <span class="mark-text highlight">了不起的甲骨文</span>
            等产品，参会者可以现场体验AI创作图像视频、与智能数智人互动等功能，感受前沿AI产品带来的科技魅力。 
          </p>
          <div>
            <div class="image-panel">
              <img class="news-image" src="../img/detail/Information/news57/news57_3.png"/>
            </div>
          </div>
          <p>作为腾讯旗下顶级的AI实验室，腾讯优图实验室自成立以来，始终聚焦人工智能领域在多行业场景的研究与落地，未来，腾讯优图实验室将持续推进AI技术创新，以科技助力各行业数字化转型，让AI更好地融入到生产力发展之中。</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
  export default {
    name: 'News57',
    components: {
      BackOpenChenter
    }
  };
  </script>
  
  <style lang="less" scoped>
  @import "./news.less";
  .news-content {
    margin: 0 auto;
    .image-panel {
      max-width: 667px;
      text-align: center;
      img {
        max-width: 667px;
      }
      span {
        font-size: 12px;
        color: #858585;
      }
    }
    .highlight {
      color: #0052FF;
    }
    .end-divide {
      width: 120px;
      height: 2px;
      margin: 20px auto;
      background: #0152d9;
    }
    .download-article-wrap {
      margin: 0 auto;
      padding: 5px 3px;
      border: 3px solid rgb(1, 82, 217);
      font-family: PingFangSC-light;
      .download-article {
        padding: 5px 10px;
        border-left: 1px solid rgb(1, 82, 217);
        border-right: 1px solid rgb(1, 82, 217);
      }
    }
    .news-literature {
      max-height: 180px;
      padding: 15px;
      overflow-y: scroll;
      background-color: #ebebeb;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News57.vue